export default __webpack_public_path__ + "static/media/turn-logo-black.44529e9f92a38d5bdabbc9d613ff5886.svg";